const X = {
  XS: 0,
  SM: 576,
  MD: 768,
  LG: 992,
  XL: 1200,
  XXL: 1400,
  XXXL: 1680,
  FIXED: 1440
}, r = (e) => e < X.SM ? "XS" : e < X.MD ? "SM" : e < X.LG ? "MD" : e < X.XL ? "LG" : e < X.XXL ? "XL" : e < X.XXXL ? "XXL" : "XXXL";
export {
  X as Breakpoints,
  r as getCurrentBreakpoint
};
//# sourceMappingURL=index.js.map
